'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';


const ReactPlayer = dynamic(() => import('react-player/youtube'), { ssr: false });
const Video = ({ url, className, background }: any) => {
  const [mounted, mount] = useState(false);
  const [muted, mute] = useState(true);
  // const [poster, showPoster] = useState(true);

  useEffect(() => {
    mount(true);
    return () => mount(false);
  }, []);

  return (
    <>
      <div className={`banner relative flex items-center justify-center bg-black ${className}`}>
        {mounted && url && (
          <ErrorBoundary onError={(error) => { console.error('Video: ReactPlayer error', error); }} fallback={null}>
            <ReactPlayer
              className="pre-banner-video-container"
              width="100%"
              height="100%"
              url={url}
              muted={muted}
              loop={true}
              playing={true}
              // onPlay={() => showPoster(false)}
              config={{
                playerVars: { showinfo: 0, disablekb: 0 },
              }}
            />
          </ErrorBoundary>
        )}
      </div>
      <style jsx global>{`
        .pre-banner-video-container {
          position: absolute;
          top: 0;
          bottom: 0;
          width: 100%;
          overflow: hidden;
          height: ${background?.includes('iframe') || background?.includes('vimeo') || background?.includes('youtu')
          ? '200vh !important'
          : '100% !important'};
        }
        .pre-banner-video-container video {
          /* Make video to at least 100% wide and tall */
          min-width: 100%;
          min-height: 1000vh;

          /* Setting width & height to auto prevents the browser from stretching or squishing the video */
          width: auto;
          height: auto;

          /* Center the video */
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      `}</style>
    </>
  );
};

export default Video;